import { render, staticRenderFns } from "./LoanPaymentDetail.vue?vue&type=template&id=c4e97234&"
import script from "./LoanPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./LoanPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports